import { initialState } from '@/vuex/store'

export default {
  SET_JWT: (state, payload) => {
    state.token = payload.token
  },
  SET_USER: (state, payload) => {
    state.user = payload.user
  },
  SET_USER_RELATED: (state, payload) => {
    state.related = payload.related
  },
  SET_HISTORY_URL: (state, payload) => {
    state.historyUrl = payload.historyUrl
  },
  SET_MENU: (state, payload) => {
    state.menu = payload.menu
  },
  SET_ACTIONS: (state, payload) => {
    state.actions = payload.actions
  },
  SET_JWT_EXPIRED: (state, payload) => {
    state.jwtExpired = payload.jwtExpired
  },
  SET_PERMISSIONS: (state, payload) => {
    state.permissions = payload.permissions
  },
  SET_SEARCH_EMPLOYEE_RRHH: (state, payload) => {
    state.search = payload.search
  },
  SET_SEARCH_DOCUMENT_RRHH: (state, payload) => {
    state.documentSearch = payload.documentSearch
  },
  SET_ESTADO_EMPRESA: (state, payload) => {
    state.estadoEmpresa = payload.estadoEmpresa
  },
  SET_DROP_ZONE: (state, payload) => {
    state.dropzoneImg = payload.dropzoneImg
  },
  SET_VALIDATE_SECTION: (state, payload) => {
    state.validateSection = payload.validateSection
  },
  SET_SECTIONS: (state, payload) => {
    state.sections = payload.sections
  },
  RESET_STORE: (state) => {
    let newState = initialState()
    Object.assign(state, newState)
  },
  SET_INITIAL_COUNTRY: (state, payload) => {
    state.country = payload
  },
  SET_LIMIT_BY_PAGE: (state, payload) => {
    state.limit = parseInt(payload)
  },
  SET_LOADING: (state, payload) => {
    state.loading = payload
  },
  SET_INITIAL_ONBOARDING_LIST: (state, payload) => {
    state.onBoardingList = payload
  },
  SET_USER_LIST: (state, payload) => {
    state.userList = payload
  },
  SET_ACTIVATE_DATE: (state, payload) => {
    state.activateDate = payload
  },
  SET_CARTELERA_HOME: (state, payload) => {
    state.carteleraHome = payload
  },
  SET_HOME_SECTORES_BIRTHDAYS: (state, payload) => {
    state.sectoresBirthdays = payload
  },
  SET_HOME_SECTORES_RECENT_HIRED: (state, payload) => {
    state.sectoresRecentHired = payload
  },
  SET_POPUP_MANTENIMIENTO_VISUALIZATIONS: (state, payload) => {
    state.popupMantenimientoVisualizations = payload
  },
  SET_POPUP_SICHERN_VISUALIZATIONS: (state, payload) => {
    state.popupSichernVisualizations = payload
  },
  SET_MSG_OUTAGE: (state, payload) => {
    state.msgOutage = payload
  },
  SET_NOTIFY_PUSH_VISUALIZATIONS: (state, payload) => {
    state.notifyPushVisualizations = payload
  },
  SET_NOTIFY_PUSH: (state, payload) => {
    state.notifyPush = payload
  },
  SET_POPUP_FILE_UP_LICENSES: (state, payload) => {
    state.popupFileUploadLicensesVisualizations = payload
  },
  SET_SSO_DATA: (state, payload) => {
    state.SSOData = payload
  },
  SET_DOCUMENTS_WAITING: (state, payload) => {
    state.documentsWaiting = payload
  },
  SET_COMPANY_LOGO: (state, payload) => {
    state.companyLogo = payload
  },
  SET_PARAM_FACTORY: (state, data) => {
    state.queryParams.params.factory = data
  },
  SET_PROFILE: (state, profile) => {
    state.profile = profile
  },
  CLEAR_PROFILE: (state) => {
    state.profile = {}
  },
  SET_NEW_DOCUMENTS_WAITING: (state, payload) => {
    state.newDocumentsWaiting = payload
  },
  SET_CLEAN_ACTION: (state, payload) => {
    state.cleanAction = payload
  },
  SET_PAYROLL_STATUS: (state, payload) => {
    state.payrollStatus = { ...state.payrollStatus, ...payload }
  },
  SET_PEOPLEOB_STATUS: (state, payload) => {
    state.peopleOnboarding = payload
  },
  SET_PERFORMANCE_INTEGRATION: (state, payload) => {
    state.hasPerformanceIntegration = payload
  },
  SET_INTEGRATIONS: (state, payload) => {
    state.integrations = payload
  },
  UPDATE_PERMISSIONS: (state, newPermission) => {
    if (!state.permissions.includes(newPermission)) {
      state.permissions.push(newPermission)
    }
  }
}
